<template>
  <div>
      <div class="breadcrumbs-container">
            <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
            <ul>
                <li>
                  <router-link :to="{name: 'Home'}">  
                    Home
                  </router-link>
                </li>
                <li>
                  <router-link  :to="{name: 'Kitchen', params: {id: mealData.user_id}}">  
                    {{mealData.kitchen_name}}'s Kitchen
                  </router-link>                        
                </li>
                <li class="is-active">
                  <a href="#">  
                      {{mealData.name}}
                  </a>                        
                </li>
            </ul>
            </nav>
        </div>
    <section>
      <div class="container radley">
        <div class="columns">
          <div class="column">
          <div>
            <div class="circular" v-if="mealData.mainImage" :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + mealData.mainImage + '?alt=media)' }" />
            <div class="circular" v-else :style="{ backgroundImage: 'url(https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + mealData.recipes[0].mainImage[0] + '?alt=media)' }" />
        </div>                               
        <!-- Post meta -->    
        <div class="has-text-centered mb-20">       
            <span class="is-capitalized is-size-1 caveat">    
                {{mealData.name}}    
            </span>              
        <!-- subtitle -->  
        <p class="is-size-4">{{mealData.subtitle}}</p>  
        </div>
              <!-- Post body -->
              <div class="content">
                <div
                  v-for="recipe in mealData.recipes"
                  :key="recipe.id"
                >
                  <div class="has-text-centered mt-50">
                    <h1 class="is-size-1 has-text-weight-light">
                      <span class="caveat">{{ recipe.name }}</span>
                    </h1>
                  </div>
                  <nav class="level time-serving-levels">    
                  <div class="level-item has-text-centered">    
                      <div>    
                          <p class="heading">Total Prep Time</p>    
                          <p class="title">
                              <span v-if="recipe.prepTime.hours > 0">{{recipe.prepTime.hours}} hr </span>
                              <span v-if="recipe.prepTime.minutes > 0">{{recipe.prepTime.minutes}} min</span>
                              <span v-if="(recipe.prepTime.minutes + recipe.prepTime.hours) == 0">0 min</span>
                          </p>
                      </div>    
                  </div>    
                  <div class="level-item has-text-centered">    
                      <div>    
                          <p class="heading">Total Cook Time</p>    
                          <p class="title">
                              <span v-if="recipe.cookTime.hours > 0">{{recipe.cookTime.hours}} hr </span>    
                              <span v-if="recipe.cookTime.minutes > 0">{{recipe.cookTime.minutes}} min</span>
                              <span v-if="(recipe.cookTime.minutes + recipe.cookTime.hours) == 0">0 min</span>
                          </p>
                      </div>    
                  </div>  
                  <div class="level-item has-text-centered">    
                      <div>    
                          <p class="heading">Servings</p>    
                          <p class="title">
                              <span>{{recipe.servings}}</span>    
                          </p>
                      </div>    
                  </div>       
              </nav>
                   <b-message type="is-primary" class="mt-20" v-if="recipe.quickreference">
                        <div class="media quickreference">
                            <div class="media-left">
                            <b-icon
                                pack="fas"
                                icon="lightbulb"
                                size="is-large">
                            </b-icon>
                            </div>
                            <div class="media-content">
                                {{recipe.quickreference}}
                            </div>
                        </div>            
                    </b-message>
                  <div>
                  <div class="columns">
                  <div class="column is-4 ingredient-list">
                  <b-collapse
                      class="card">
                      <div
                          slot="trigger"
                          slot-scope="props"
                          class="card-header recipe-header"
                          role="button">
                          <p class="card-header-title">
                              Ingredients
                          </p>
                          <a class="card-header-icon">
                              <b-icon
                              pack="fas"
                                  :icon="props.open ? 'caret-up' : 'caret-down'">
                              </b-icon>
                          </a>
                      </div>
                      <div class="card-content">
                          <div class="content">
                                  <table class="table is-striped">  
                                  <tbody>
                                      <tr v-for="ingredient in recipe.ingredients" :key="ingredient.id">
                                      <td>   
                                      <div class="field">
                                          <b-checkbox>
                                              <span v-html="ingredient.amount"></span> {{ingredient.measurement}}, {{ingredient.ingredient}}
                                          </b-checkbox>
                                      </div>                                                            
                                      </td>
                                      </tr>
                                      </tbody>
                                  </table>
                              <div class="mt-50" v-if="recipe.secondPart != null">   
                                  <h3 class="is-size-5 p-12">For the {{recipe.secondPart.name}}</h3>                 
                                  <table class="table is-striped">  
                                  <tbody>
                                      <tr v-for="ingredient in recipe.secondPart.ingredients" :key="ingredient.id">
                                      <td>   
                                      <div class="field">
                                          <b-checkbox>
                                              <span v-html="ingredient.amount"></span>&nbsp;<span v-if="ingredient.measurement">{{ingredient.measurement}},&nbsp;</span>{{ingredient.ingredient}}
                                          </b-checkbox>
                                      </div>                                                            
                                      </td>
                                      </tr>
                                      </tbody>
                                  </table>
                              </div> 
                          </div>
                      </div>
                  </b-collapse> 
                  </div>
                  <div class="column is-8">
                  <b-collapse class="card">
                      <div
                          slot="trigger"
                          slot-scope="props"
                          class="card-header recipe-header"
                          role="button">
                          <p class="card-header-title">
                              Instructions
                          </p>
                          <a class="card-header-icon">
                              <b-icon
                              pack="fas"
                                  :icon="props.open ? 'caret-up' : 'caret-down'">
                              </b-icon>
                          </a>
                      </div>
                      <div class="card-content">
                          <div class="content">
                              <!-- Post content -->    
                              <div v-for="(item,index) in recipe.steps" :key="item.id">    
                                  <div v-if="item.image" class="columns">
                                      <div class="column is-two-thirds step-flex">    
                                          <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                          <div class="step-content"><span>{{item.text}}</span></div>  
                                      </div>    
                                      <div class="column is-one-third">    
                                          <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                      </div>   
                                  </div>
                                  <div v-else>
                                      <div class="step-flex">    
                                          <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                          <div class="step-content"><span>{{item.text}}</span></div> 
                                      </div>   
                                  </div>   
                              </div> 
                              <div class="mt-50" v-if="recipe.secondPart != null">
                                  <h3 class="is-size-5 p-12">For the {{recipe.secondPart.name}}</h3> 
                                  <div v-for="(item,index) in recipe.secondPart.steps" :key="item.id">    
                                      <div v-if="item.image" class="columns">
                                          <div class="column is-two-thirds step-flex">    
                                              <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div>
                                              <div class="step-content"><span>{{item.text}}</span></div>  
                                          </div>    
                                          <div class="column is-one-third">    
                                              <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/'+item.image+'?alt=media'" style="width:100%;" />    
                                          </div>   
                                      </div>
                                      <div v-else>
                                          <div class="step-flex">    
                                              <div class="list-number"><span class="is-size-4">{{index + 1}}.&nbsp;</span></div> 
                                              <div class="step-content"><span>{{item.text}}</span></div> 
                                          </div>   
                                      </div>   
                                  </div>
                              </div>
                          </div>
                      </div>
                  </b-collapse> 
                  </div>
                  </div>
                  
                  </div>
                                 
                <hr>
                </div>
                <div class="has-text-centered">
                  <carousel
                    :navigationEnabled="true"
                    :perPage="1"
                    paginationColor="rgba(0, 0, 0, 0.25)"
                  >
                    <slide v-if="mealData.mainImage">
                      <img :src="'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' + mealData.mainImage + '?alt=media'" />
                      <div>{{ mealData.name }}</div>
                    </slide>
                    <slide v-for="recipe in mealData.recipes" :key="recipe.id">
                      <img v-if="recipe.mainImage[0]"
                        :src="
                          'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' +  recipe.mainImage[0] + '?alt=media'" />
                      <div class="is-size-4 has-text-centered">
                        {{ recipe.name }}
                      </div>
                    </slide>
                  </carousel>
                </div>
                <div
                  class="author-name is-capitalized is-size-3 has-text-centered"
                >
                  From the kitchen of
                  <b
                    ><a href="#">{{ userData.name }}</a></b
                  >
                </div>
                <div class="is-size-5 has-text-centered">
                  <i class="sl sl-icon-clock"></i> {{ created_at }}
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /Post section -->
  </div>
</template>

<script>
import firebase from "@/firebase";
import db from "@/db";
import moment from "moment";
import { mapState } from "vuex";
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "Meal",
  data() {
    return {
      id: this.$route.params.id,
      user_id: null,
      mealData: {
        prepTime: {
          hours: 0,
          minutes: 0
        },
        cookTime: {
          hours: 0,
          minutes: 0
        }
      },
      userData: Object,
      created_at: String,
      isActive: false,
      rating: null,
      latestRecipes: []
    };
  },
  components: {
    Carousel,
    Slide
  },
  async mounted() {
    await this.fetchData();
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.user_id = user.uid;
      } else {
        console.log("not logged in");
      }
    });
  },
  watch: {
    $route: "fetchData"
  },
  computed: mapState("auth", ["user", "isLoggedIn"]),
  methods: {
    fetchData() {
      db.collection("meals")
        .doc(this.id)
        .get()
        .then(docSnapshot => {
          if (!docSnapshot.exists) return;
          this.mealData = docSnapshot.data();
          this.created_at = moment(this.mealData.created_at.toDate()).fromNow();

          for(let i = 0; i < this.mealData.recipes.length; i++) {
              let recipe =this.mealData.recipes[i];
                if(this.mealData.recipes[i].secondPart != null) {
                      db.collection("recipes")
                      .doc(this.mealData.recipes[i].secondPart.id)
                      .get()
                      .then((docSnapshot) => {
                      if (!docSnapshot.exists) {
                          console.log('doesnt exist');
                      }
                      recipe = docSnapshot.data();
                      this.mealData.recipes[i].secondPart = recipe;
                      });
                  }
                  else {
                      this.mealData.recipes[i].secondPart = null;
                  }
                  
              }

          db.collection("users")
            .doc(this.mealData.user_id)
            .get()
            .then(docSnapshot => {
              if (!docSnapshot.exists) return;
              this.userData = docSnapshot.data();
            });
        });

      // db.collection('meals').orderBy("created_at").limit(5).get().then((querySnapshot) => {
      //     querySnapshot.forEach((doc) => {
      //         this.latestRecipes.push(doc.data());
      //     })
      // });
    },
  }
};
</script>
